import React, { lazy, Suspense } from "react";
import { observer } from "mobx-react";
import { injectMainStore } from "@cuba-platform/react";
import { Spin } from "@shared/antd/spin";
import { ROUTES } from "../../mobile-routes";

const MyPortalFeedbackQuestionsPageLazy = lazy(() => import("@pages/PortalFeedbackQuestions/my-portal-feedback-questions-page"));

@injectMainStore
@observer
export class PortalFeedbackQuestionsListManagement extends React.Component {
  static PATH = ROUTES.portalFeedbackQuestionsList.desktop;
  static NEW_SUBPATH = "new";

  render() {
    return (
      <>
        <Suspense fallback={<Spin spinning={true} />}>
          <MyPortalFeedbackQuestionsPageLazy />
        </Suspense>
      </>
    );
  }
}
